import React from "react";
import ReactDOM from "react-dom/client";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Curewell from "./Curewell";

/* ================= IMAGE LOAD HELPERS ================= */

const loadImages = (container) => {
  return new Promise((resolve) => {
    const imgs = container.getElementsByTagName("img");
    if (!imgs.length) return resolve();

    let loaded = 0;
    for (let img of imgs) {
      img.crossOrigin = "anonymous";

      if (img.complete) {
        loaded++;
        if (loaded === imgs.length) resolve();
      } else {
        img.onload = img.onerror = () => {
          loaded++;
          if (loaded === imgs.length) resolve();
        };
      }
    }
  });
};

/* ================= MAIN PDF FUNCTION ================= */

const curewellVoucherPrint = async (
  clinic,
  qrCodeUrl,
  item,
  referrerId,
) => {
  const address = `
    ${clinic?.clinicAddress?.plot ? clinic.clinicAddress.plot + ", " : ""}
    ${clinic?.clinicAddress?.area ? clinic.clinicAddress.area + ", " : ""}
    ${clinic?.clinicAddress?.street ? clinic.clinicAddress.street + ", " : ""}
    ${clinic?.clinicAddress?.landMark ? clinic.clinicAddress.landMark + ", " : ""}
    ${clinic?.clinicAddress?.city?.name ? clinic.clinicAddress.city.name + ", " : ""}
    ${clinic?.clinicAddress?.state?.name ? clinic.clinicAddress.state.name + ", " : ""}
    ${clinic?.clinicAddress?.country?.name ? clinic.clinicAddress.country.name + ", " : ""}
    ${clinic?.clinicAddress?.pin || ""}
  `.trim();

  /* ===== Hidden container ===== */

  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.top = "-10000px";
  container.style.left = "0";
  container.style.width = "794px"; // A4 width in px
  container.style.background = "#ffffff";
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);

  root.render(
    <Curewell
      clinic={clinic}
      address={address}
      qrCodeUrl={qrCodeUrl}
      item={item}
      selectedItem={item?.appointmentDetails || item}
      referrer={referrerId}
      reportType="invoice"
    />
  );


  await loadImages(container);
  await new Promise((r) => setTimeout(r, 1000));


  const canvas = await html2canvas(container, {
    scale: 3, 
    useCORS: true,
    backgroundColor: "#ffffff",
    scrollY: -window.scrollY,
  });

  const imgData = canvas.toDataURL("image/png");

  /* ================= PDF MULTI PAGE ================= */

  const pdf = new jsPDF("p", "mm", "a4");

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pdfWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  heightLeft -= pdfHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;
  }

  pdf.save("CurewellReport.pdf");

  root.unmount();
  document.body.removeChild(container);
};

export default curewellVoucherPrint;